import { Component, OnInit, Input } from '@angular/core';
import { User } from './user';
import { AuthenticationService, UserService } from '../_services';
import { environment } from 'src/environments/environment';
import { Authenticate } from '../authenticate/authenticate';
import { Router, ActivatedRoute } from '@angular/router';
import { Machine } from '../machine/machine';
import { MachineService } from '../machine/machineService';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.less']
})
export class UserComponent implements OnInit {
  @Input() currentUser: User;
  ticketcount: number;
  uu = environment.appURL;
  auth: Authenticate;
  returnUrl: string;
  mcount: number;
  machines: Machine[];
  checked: number = 0;
  isIssam= false; 


  constructor(private authservice: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private machineservice: MachineService) { 


   /*   router.events.subscribe(() => {

        try {
          this.auth = null;
          this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
          this.machines = JSON.parse(sessionStorage.getItem('clientMachines'));
          if (this.auth != null) {
            this.thecurrentuser = this.auth.user;
            this.currentUser = this.thecurrentuser;
            console.log(this.currentUser.username);
           if (this.thecurrentuser != null) {
              this.ticketcount = this.thecurrentuser.tickets.length;
              if (this.currentUser.username == "issam") {this.isIssam = true}
        
            }
          }
        }
        catch {
          console.log("Some error came up");
        }
      })*/
    }
  thecurrentuser: User;

  //----------------------------------------------------
  //  PAGE LOAD FUNCTION
  //----------------------------------------------------
  ngOnInit() {
    try {
      this.auth = null;
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      this.machines = JSON.parse(sessionStorage.getItem('clientMachines'));
      if (this.auth != null) {
        this.thecurrentuser = this.auth.user;
        this.currentUser = this.thecurrentuser;
       if (this.thecurrentuser != null) {
          this.ticketcount = this.thecurrentuser.tickets.length;
          if (this.currentUser.username == "issam") {this.isIssam = true}
    
        }
      }
    }
    catch {
      console.log("Some error came up");
    }
  
   }


  ngAfterContentChecked() {
    if (this.checked < 500) {
      if (this.auth) {
        this.getMachinesCount();
        this.checked = 1000;
      }
      this.checked++;
    }
  }

  //----------------------------------------------------
  //  GET USER MACHINES COUNTER 
  //----------------------------------------------------
  getMachinesCount() {
    this.machineservice.getClientMachines(this.currentUser.client.id).subscribe(res => {
      this.machines = res;
      this.mcount = this.machines.length;
    });
  }

  //----------------------------------------------------
  //  LOGOUT AND CLEAR COOKIES
  //----------------------------------------------------
  logout() {
    this.returnUrl = environment.appURL
    this.authservice.logout();
    this.router.navigate([this.returnUrl]);
    window.location.href = environment.ticketingURL;
  }
}
